import React from "react";
import { styled, useStyletron } from "baseui";
import { BounceLoader } from "react-spinners";
const LoadingContainer = styled('div', {
    display: 'flex',
    flexDirection: 'column',  // This will stack children vertically
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh'
});

const LoadingText = styled('p', {
    textAlign: 'center',
    marginTop: '1rem',
    fontSize: '24px',  // Increase font size for larger text
    color: 'black'
});
const BounceSpinnerWrapper = styled('div', ({ $theme }) => ({
    color: $theme.colors.accent400 // Here we access the theme directly
}));
export default function LoadingComponent(props) {
  const [_, theme] = useStyletron();

    return (
        <LoadingContainer>
            <BounceSpinnerWrapper>
                <BounceLoader color={theme.colors.accent} size={200} /> 
            </BounceSpinnerWrapper>
            <LoadingText>Fetching User Info...</LoadingText>
        </LoadingContainer>
    );
}